import React from 'react';
import {Tag} from 'antd';

const StatusNFe = ({status}) => {
    if(status == "AUTORIZADA"){
        return <Tag style={{color: "green", float: "right"}}>NFe Emitida</Tag>
    } else {
        return <></>
    }
}

export {StatusNFe};